/* eslint-disable @typescript-eslint/restrict-template-expressions -- used purposefully for assert */
export function assertNever(n: never): never {
    throw new Error(`Unexpected value ${n}.`);
}
/* eslint-enable @typescript-eslint/restrict-template-expressions */
